import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames/bind';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import withComponentName from '../../../../decorators/withComponentName';
import { setTypesFilter, setYearsFilter, setPeriodsFilter } from '../../../../actions/investorRelations.actions';

import TypesFilter from '../../CommonComponent/FilterBar/TypesFilter';
import YearsFilter from '../../CommonComponent/FilterBar/YearsFilter';
import PeriodsFilter from '../../CommonComponent/FilterBar/PeriodsFilter';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const FilterBar = (props) => {
  const {
    isFilterOpen, onReset, isReset, handleFilterClose, piwikEnabled,
  } = props;

  const { width, investorRelations } = useSelector(({
    common, investorRelations: relationsProps,
  }) => ({
    width: common.width,
    investorRelations: relationsProps,
  }));

  const dispatch = useDispatch();
  const propsSetTypes = (param) => {
    dispatch(setTypesFilter(param));
  };
  const propsSetYears = (param) => {
    dispatch(setYearsFilter(param));
  };
  const propsSetPeriods = (param) => {
    dispatch(setPeriodsFilter(param));
  };

  const providerFilterClass = cx('provider_filter', { active: isFilterOpen });

  return (
    <div className={providerFilterClass}>
      <div
        className={cx('story-filter__close-btn')}
        onClick={handleFilterClose}
      >
        <FontAwesomeIcon icon={faXmark} />
      </div>
      <TypesFilter
        width={width}
        isReset={isReset}
        savePropsData={propsSetTypes}
        isAllTypesSelected={investorRelations.isAllTypesSelected}
        selectedTypes={investorRelations.selectedTypes}
        piwikEnabled={piwikEnabled}
      />
      <YearsFilter
        width={width}
        isReset={isReset}
        savePropsData={propsSetYears}
        isAllYearsSelected={investorRelations.isAllYearsSelected}
        fromYear={investorRelations.fromYear}
        toYear={investorRelations.toYear}
        piwikEnabled={piwikEnabled}
      />
      <PeriodsFilter
        width={width}
        isReset={isReset}
        savePropsData={propsSetPeriods}
        isAllPeriodsSelected={investorRelations.isAllPeriodsSelected}
        selectedPeriods={investorRelations.selectedPeriods}
        piwikEnabled={piwikEnabled}
      />
      <Button className={Styles.provider_filter_reset} onClick={onReset} variant="default">
        <span>Reset</span>
      </Button>
    </div>
  );
};

export default withComponentName(FilterBar);
